import { Link } from "gatsby"
import PropTypes from "prop-types"
import React from "react"
import styled from "styled-components";

import logo from '../images/logo-white.svg';

const Container = styled('header')`
  background-color: ${props => props.theme.colors.primary};
  padding: 2rem;
  text-align: center;
`;

const HeaderLink = styled(Link)`
  color: white;
  font-weight: 600;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const Logo = styled('img')`
  margin-right: 1rem;
`;

const Header = ({ siteTitle }) => (
  <Container>
    <h1>
      <HeaderLink to="/">
        <Logo src={logo} width={24} height={24} alt="COVID-19-logo" />
        {siteTitle}
      </HeaderLink>
    </h1>
  </Container>
)

Header.propTypes = {
  siteTitle: PropTypes.string,
}

Header.defaultProps = {
  siteTitle: ``,
}

export default Header
